import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaHeadset,
  FaCalendarAlt,
  FaFileInvoiceDollar,
  FaMapMarkerAlt,
} from "react-icons/fa";
import FeaturesIcon from "../../../assets/images/single_image-01.webp";

const Features = () => {
  return (
    <section className="features-section clearfix">
      <div className="container">
        <div className="row align-items-center">
          {/* Image Section */}
          <div className="col-xl-6 col-lg-6 col-md-9 col-sm-10 mx-auto mb-4 mb-lg-0">
            <div className="cmt_single_image-wrapper">
              <img
                className="img-fluid rounded"
                src={FeaturesIcon}
                alt="About Us"
              />
            </div>
          </div>

          {/* Content Section */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="pt-3 ps-lg-4">
              {/* Section Title */}
              <div className="section-title mb-4">
                <div className="title-header">
                  <h3>Key Features</h3>
                  <h2 className="title">
                    Smart features for smarter society management.
                  </h2>
                </div>

                <div className="title-desc mt-3">
                  <p>
                    Our platform offers a complete set of smart tools designed
                    to simplify day-to-day society operations.
                  </p>
                  <p>
                    From automated billing and transparent accounting to secure
                    visitor management and emergency alerts, every feature is
                    built to save time and reduce manual effort.
                  </p>
                </div>
              </div>

              {/* Features */}
              <div className="border-top border-bottom py-4 mb-4">
                <div className="row g-2">
                  <div className="col-sm-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3 text-primary fs-2">
                        <FaMapMarkerAlt />
                      </div>
                      <div>
                        <h5 className="mb-0">Live Location Search</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3 text-primary fs-2">
                        <FaFileInvoiceDollar />
                      </div>
                      <div>
                        <h5 className="mb-0">Upfront Estimates</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3 text-primary fs-2">
                        <FaCalendarAlt />
                      </div>
                      <div>
                        <h5 className="mb-0">Flexible Booking</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="me-3 text-primary fs-2">
                        <FaHeadset />
                      </div>
                      <div>
                        <h5 className="mb-0">In-app Chat & Call Support</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Button */}
              <Link
                to="/about-us"
                className="primary_btn btn btn-primary rounded-pill px-4"
              >
                Read More <FaArrowRight className="ms-2" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
